import React from 'react';
import  Class7Fieldtrip2024  from 'views/Class7Fieldtrip2024';

const VissionAndMissionPage = () => {
  return <Class7Fieldtrip2024/>;
};

export default VissionAndMissionPage;